import React, { Component, forwardRef } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { ColorButton, FiltersContainer, HeadingContainer, RecordOptions, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { withRouter } from 'react-router-dom';
import MessagingEditor from './MessagingEditor';
import { IconButton, TableContainer, Tooltip } from '@material-ui/core';
import { Box, CloseButton, Group, Input, Loader, MultiSelect, Popover, Select, Skeleton, Stack, Tooltip as MantineTooltip } from '@mantine/core';
import Up from '../../../../assets/images/module/general/SelectArrowUp.svg';
import Down from '../../../../assets/images/module/general/SelectArrowDown.svg';
import MessagingEditorMantine from './MessagingEditorMantine';
import Avatar from '../../../../assets/images/module/general/userAvatar.svg';
import defaultAvatar from '../../../../assets/images/module/general/defaultAvatarPicture.svg';
import SearchIcon from '../../../../assets/images/module/general/SearchIcon.svg';
import AddTenantBlue from '../../../../assets/images/module/general/AddTenantBlue.svg';
import AddAllTenantsBlue from '../../../../assets/images/module/general/AddAllTenantsBlue.svg';
import RemoveAllTenantsBlue from '../../../../assets/images/module/general/RemoveAllTenantsBlue.svg';
import breadcrumbsContent from '../../../../assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import RightArrowPartner from '../../../../assets/images/module/general/RightArrowPartner.svg';
import PrintIconBlue from '../../../../assets/images/module/general/PrintIconBlue.svg';
import SelfIcon from '../../../../assets/images/module/general/SelfIcon.svg';
import TenantSingleIcon from '../../../../assets/images/module/general/TenantSingleIcon.svg';
import TenantSingleIconBlue from '../../../../assets/images/module/general/TenantSingleIconBlue.svg';
import TenantLiteIcon from '../../../../assets/images/module/general/TenantLite.svg';
import buildingIcon from '../../../../assets/images/module/general/building_icon.svg';
import GoldenLockIcon from '../../../../assets/images/module/general/GoldenLockIcon.svg';
import BlueTick from '../../../../assets/images/module/general/BlueTick.svg'
import PdfIconWhite from '../../../../assets/images/module/general/PdfNewIconWhite.svg';
import PdfIcon from '../../../../assets/images/module/general/PdfNewIcon.svg';
import ResetIcon from '../../../../assets/images/module/general/ResetIcon.svg';
import { setUtilityBillingData, setCurrentBillingId } from '../../../../redux/action/UtilityBilling/UtilityBillingActions';
import { setPublishMessageId, setRefreshMessagesData, setAccountData, setCurrentMessagesData, setMessageTemplates } from '../../../../redux/action/General/generalActions';

import AddIcon from '@material-ui/icons/Add';
import { connect } from 'react-redux';
import AddMessagingRecipientsModal from '../../../../neoverv/components/Module/General/CustomModal/AddMessagingRecipientsModal';
import { hideNotification, showNotification } from '@mantine/notifications';
import MessagingPricingModal from '../../../../neoverv/components/Module/General/CustomModal/MessagingPricingModal';
import { formatNumber } from '../../../../helpers/stringsManipulations';
import MessagePreviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePreviewModal';
import AiMessageAssistantModal from '../../../../neoverv/components/Module/General/CustomModal/AiMessageAssistantModal';
import { isAiFeatureVisible } from '../../../../helpers/aiFeatureAccess';
import { getAvailablePlaceholderLabels } from '../../../../helpers/messagePlaceholders';
import { EditorState, ContentState, convertToRaw, Modifier, RichUtils, getDefaultKeyBinding } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import MessageConfirmationModal from '../../../../neoverv/components/Module/General/CustomModal/MessageConfirmationModal';
import MessageDeleteModal from '../../../../neoverv/components/Module/General/CustomModal/MessageDeleteModal';
import dayjs from 'dayjs';
import BulkDownloadForMessageModal from '../../../../neoverv/components/Module/General/CustomModal/BulkDownloadForMessageModal';
import DeleteIcon from '@material-ui/icons/Delete';
import DownloadIcon from '../../../../neoverv/components/SVGs/downloadIcon';
import TemplateServices from '../../../../neoverv/helpers/services/TemplateServices';
import ChordComponent from './decorators/ChordComponent';
import CustomMultiSelect from '../../../../neoverv/components/Module/General/CustomMultiSelect/CustomMultSelect';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { loader, checkProperty } = Autoload.MainHelper;

const MOBILE_SIZE = 992;

  function Value({
    value,
    label,
    onRemove,
    classNames,
    messageData,
    onClick,
    ...others
  }) {
    console.log('Value: ', value, label, others);
    return (
        <Group gap={0} className='message-card-ten-cards' key={value} wrap="nowrap" style={{height: '20.6px', maxHeight: '20.6px', background: '#F2F2FC', paddingRight: 3, marginRight: '3px'}}>
            <Group wrap="nowrap" gap={5} style={{minWidth: '55px', paddingRight: '5px'}} onClick={()=> onClick(value)}>
                <Group style={{background: '#454576', width: '18px', borderRadius: '120px', height: '18px'}} justify='center' align={'center'}>
                  <span style={{textTransform: 'capitalize', color: 'white'}}>{others?.name && others?.name[0]}</span>
                </Group>
                <span style={{whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{others?.name}</span>
            </Group>
            {messageData?.templateType !== 'RentalPayment' &&
            <Group>
              <MantineTooltip label="Empfänger entfernen" withinPortal zIndex={9999999}>
                <CloseButton
                onMouseDown={onRemove}
                variant="transparent"
                size={15}
                iconSize={14}
                tabIndex={-1}
                />
              </MantineTooltip>
            </Group>}
        </Group>
    );
  }
  
  const Item = forwardRef(({ label, value, ...others }, ref) => {
    console.log('Item: ', label, value, others);
    //const Flag = flags[value];
    return (
      <div ref={ref} {...others}>
        {/* <Box style={{ display: 'flex', alignItems: 'center' }}>
          <Box mr={10}>
            <img src={others.picture}/>
          </Box>
          <div>{others.name}</div>
        </Box> */}
        <Group gap={5} className='message-card-ten-cards' key={value} style={{height: '20.6px', maxHeight: '20.6px', background: 'transparent', width: 'auto'}}>
            <img src={others.picture} style={{height: '18.6px', maxHeight: '18.6px'}}/>
            <span>{others.name}</span>
        </Group>
      </div>
    );
  });

class NewMessageInnerContent extends Component {
  state = {
    tenant: [{
        value: 'id1',
        name: 'Ten1',
        picture: defaultAvatar,
        label: 'Ten1'
    }, {
        value: 'id2',
        name: 'Ten2',
        picture: Avatar,
        label: 'Ten2'
    }, {
        value: 'id3',
        name: 'Ten3',
        picture: defaultAvatar,
        label: 'Ten3'
    }, {
        value: 'id4',
        name: 'Ten4',
        picture: Avatar,
        label: 'Ten4'
    }, {
        value: 'id5',
        name: 'Ten5',
        picture: defaultAvatar,
        label: 'Ten5'
    }],
    selectedRecipients: [],
    dropdownIcon: Down,
    tenantsLength: null,
    openRecipientsModal: false,
    openMessagingPricingModal: false,
    paymentDetails: null,
    allRecipients: [],
    allRecipientsOldState: [],
    messageData: {
      id: null,
      accountId: null,
      propertyId: null,
      utilityBillingId: null,
      senderId: null,
      subject: null,
      body: null,
      status: null
    },
    messageDataOldState: {
      id: null,
      accountId: null,
      propertyId: null,
      utilityBillingId: null,
      senderId: null,
      subject: null,
      body: null,
      status: null
    },
    draftOnce: true,
    tenants: [], 
    tenantsData: [],
    messageRecipientsLoader: false,
    postalFee: null,
    openPreviewModal: false,
    messageSavingLoader: false,
    editorState: EditorState.createEmpty(),
    subjectInFocus: false,
    openPostalFeeStatus: false,
    openMessageConfirmationModal: false,
    openMessageDeletionModal: false,
    isMobile: window.innerWidth <= MOBILE_SIZE,
    openBulkMessageDownloadModal: false,
    openAiMessageAssistantModal: false,
    hoverOnStarter2: false,
    inPublishProcess: false,
    messageSavingStatusPopper: false,
    senderInfo: {
      name: null,
      street: null,
      city: null,
      postalCode: null,
      email: null,
      phoneNumber: null
    },
    defaultTemplate: null,
    messageTemplates: [],
    systemMessageTemplates: [],
    confirmMessageDeletionModal: false,
    selectedRecipientIdForEditing: null
  };

  myRef=null;
  subjectEditorRef=null;

  constructor(props){
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount(){
    TemplateServices.getSystemTemplates(this, 'handleGetSystemTemplates', null, this.props);
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState){

    // NEW: Check if either utilityBillingData OR rentalUnits have just loaded
    if(
      (prevProps.utilityBillingData.length === 0 && this.props.utilityBillingData.length > 0) ||
      (prevProps.rentalUnits.length === 0 && this.props.rentalUnits.length > 0)
    ){
      this.componentDidMountStuff();
    }

    // NEW: If recipients change, re-evaluate the Subject placeholders
    if(JSON.stringify(prevState.allRecipients) !== JSON.stringify(this.state.allRecipients)){
      if(this.state.messageData.subject){
        this.htmlToDraftConversion(this.state.messageData.subject);
      }
    }
  }

  handleResize = () => {
    // TODO: this causes data refetch on the meters reading details screen...
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  componentDidMountStuff=()=>{
    const {rentalUnits, propertySelected, numberBillingStatementTableRows, numberMeterReadingsTableRows, draftMessageDetails=null, utilityBilling, setCurrentBillingId, setUtilityBillingData, forward, replyAll, createNewTenantMessage} = this.props;
    
    this.setBeforeUnloadListener();
    
    // FIX: Initialize as an empty array instead of pulling from state 
    // to prevent duplicate tenants if this function runs twice.
    let tenants = []; 
    
    this.getPaymentDetails();
    this.getAccounts();
    this.setSenderInfo();
    this.getMessageTemplates({updateOnlyTemplatesList: true})

    if(window.location.href.includes('messaging/newMessage')){
      const triggerElements = ['utility-message-draft-3', 'utility-message-draft-cross-mobile', 'utility-message-draft-cross-desktop'];
      
      triggerElements.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.addEventListener('click', this.checkMessageData);
        }
      });
    }
    //this.postMessages('Draft');
    // if(this.props.showUtilityBillingMessages && window.location.href.includes('ub-step=billing-statements-sending')){
    //   document.getElementById("utility-message-draft").addEventListener('click', this.handleAutoSave);
    //   document.getElementById("utility-message-draft-2").addEventListener('click', this.handleAutoSave);
    // }else 
    if(this.props.showUtilityBillingMessages && window.location.href.includes('messaging/newMessage')){
      setUtilityBillingData([utilityBilling]);
      // document.getElementById("utility-message-draft-3").addEventListener('click', this.handleAutoSave);
      // console.log('utility-message-draft-3: ', document.getElementById("utility-message-draft-3"));
    }

    if(utilityBilling){
      setCurrentBillingId(utilityBilling.id);
    }
    //
    let ub= utilityBilling ? utilityBilling : this.props.utilityBillingData.find((ub1)=> ub1.id === this.props.currentDataId);
    console.log('ub: ', ub);
    rentalUnits.map((rentalUnit)=>
      rentalUnit.tenantsData.filter((row)=> row.vacant === false).map((tenant)=> {
        // selectedRecipients.push({
        //   id: tenant.id,
        //   isEmailEnabled: checkProperty(tenant, 'email', false) ? true : false,
        //   isPostEnabled: true
        // });
        if(this.props.showUtilityBillingMessages){
          if((dayjs(tenant.in, 'DD.MM.YYYY').isBefore(dayjs(ub?.billingPeriod ? ub?.billingPeriod.endDate : ub?.billingPeriodEnd))) && (tenant.out.length > 0 ? dayjs(tenant.out, 'DD.MM.YYYY').isAfter(dayjs(ub?.billingPeriod ? ub?.billingPeriod.startDate : ub?.billingPeriodStart)) : true)){
            tenants.push({
              ...tenant,
              street: propertySelected.propertyAddress,
              city: propertySelected.propertyCity,
              zipCode: propertySelected.propertyZipCode,
              value: tenant.id,
              label: tenant.name,
              isEmailEnabled: false,
              isPostEnabled: false,
              isHiddenForTenantPortal: false
            });
          }
        }else{
          tenants.push({
            ...tenant,
            street: propertySelected.propertyAddress,
            city: propertySelected.propertyCity,
            zipCode: propertySelected.propertyZipCode,
            value: tenant.id,
            label: tenant.name,
            isEmailEnabled: false,
            isPostEnabled: false,
            isHiddenForTenantPortal: false
          });
        }
        
      })
    );
    console.log('tenants_!1: ', tenants);
    this.setState({tenants}, ()=> 
    this.props.showUtilityBillingMessages && window.location.href.includes('ub-step=billing-statements-sending') ? this.getUBMessagesByUtilityBillingId() : 
      (draftMessageDetails === null || forward || replyAll || createNewTenantMessage) ? 
      this.getMessageTemplates() :
      //this.postMessages('Draft', true) : 
      this.setState({messageData: draftMessageDetails, messageDataOldState: draftMessageDetails}, ()=> {
        draftMessageDetails.subject && this.htmlToDraftConversion(draftMessageDetails.subject);
        if(draftMessageDetails.utilityBillingId){
          this.getBillingStatements(()=> this.getMessageRecipientsByMessageId(draftMessageDetails.id));
        }else{
          this.getMessagePostalFee();
          this.getMessageRecipientsByMessageId(draftMessageDetails.id);
        }
      }));
  }

  handleGetSystemTemplates(response){
    if(response.status && response.statuscode === 200){
      this.setState({systemMessageTemplates: response.result}, ()=> this.componentDidMountStuff());
    }else{
      this.componentDidMountStuff();
    }
  }

  setBeforeUnloadListener=()=>{
    window.addEventListener('beforeunload', () => {
      this.runAutoDeletionCheck(true);
    });
  }

  setSenderInfo=()=>{
    const {propertySelected, accountData} = this.props;
    let {senderInfo} = this.state;
    const {propertyOwner} = propertySelected;

    if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){ //&& (propertyOwner?.name && propertyOwner?.street && propertyOwner?.postalCode && propertyOwner?.city && propertyOwner?.email)
      senderInfo.name = propertyOwner?.name;
      senderInfo.street = propertyOwner?.street;
      senderInfo.postalCode = propertyOwner?.postalCode;
      senderInfo.city = propertyOwner?.city;
      senderInfo.email = propertyOwner?.email;
      senderInfo.phoneNumber = propertyOwner?.phoneNumber;
    }else{
      senderInfo.name = accountData?.addressCompany;
      senderInfo.street = accountData?.addressStreet;
      senderInfo.postalCode = accountData?.addressZipCode;
      senderInfo.city = accountData?.addressCity;
      senderInfo.email = accountData?.companyEmail;
      senderInfo.phoneNumber = accountData?.companyPhoneNumber;
    }

    this.setState({senderInfo});
  }

  setSubjectEditorRef=(ref)=>{
    console.log('subjectEditorRef: ', ref);
    this.subjectEditorRef= ref;
  };

  // componentDidUpdate(prevProps, prevState){

    
  // }

  compareHTML = (html1, html2) => {
    if (html1 === html2) return true;
    if (!html1 || !html2) return false;

    const normalize = (str) => {
      return str
        // 1. Revert disabled placeholders and clean injected titles
        .replace(/href="#disabled"/g, 'href="#"')
        .replace(/title="[^"]*"/g, '')
        
        // 2. NORMALIZE QUOTES: Change single quotes to double quotes
        .replace(/'/g, '"')
        
        // 3. REMOVE &nbsp;: Draft.js uses these for empty lines. Removing them 
        // turns <p>&nbsp;</p> into <p></p>, which matches your database template
        .replace(/&nbsp;/g, '')
        
        // 4. Strip line breaks, tabs, and backslashes
        .replace(/[\r\n\t\\]+/g, '')
        
        // 5. Remove all empty paragraphs entirely (cleans up spacing differences)
        .replace(/<p><\/p>/g, '')
        
        // 6. Remove spaces exactly between HTML tags (e.g., </p> <p> becomes </p><p>)
        .replace(/>\s+</g, '><')
        
        // 7. Collapse any remaining multiple spaces in the text into a single space
        .replace(/\s{2,}/g, ' ')
        
        .trim();
    };

    return normalize(html1) === normalize(html2);
  }


  checkMessageData = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
    }

    const { messageData, allRecipients, messageTemplates, systemMessageTemplates } = this.state;
    const { templateId, replyAll, forward } = this.props;
    
    let isTemplateModified = false;

    if (messageData?.templateType !== 'General') {
      let activeTemplate = messageData?.templateId
        ? messageTemplates.find(t => t.id == messageData.templateId) 
        : systemMessageTemplates.find(t => t.templateType === messageData.templateType);

      if (activeTemplate) {
        const bodyMatches = this.compareHTML(messageData.body, activeTemplate.body);
        const subjectMatches = this.compareHTML(messageData.subject, activeTemplate.subject);

        if (!bodyMatches || !subjectMatches) {
          isTemplateModified = true;
        }
      }
    }

    if(templateId || replyAll || forward || (messageData?.templateType !== 'General' && isTemplateModified)){
      // Changes detected -> Show modal
      this.setState({confirmMessageDeletionModal: true, openMessageDeletionModal: true});
      
    } else if (messageData?.templateType === 'TenantSignUp' || messageData?.templateType === 'RentalPayment') {
      // NEW: Unmodified auto-templates -> Silently delete the draft and navigate back
      // Passing "true" stops deleteMessagesById from forcing navigation to /messaging
      this.deleteMessagesById(messageData.id, true); 
      this.handleGoBack();
      
    } else if((messageData.subject === null || messageData.subject === '<p></p>\n' || messageData.subject === '') && (messageData.body === null || messageData.body === '<p></p>\n' || messageData.body === '') && allRecipients.length === 0){
      // Completely empty general draft -> delete quietly and navigate away
      this.deleteMessagesById(messageData.id);
      
    } else {
      // No unsaved changes -> Trigger the safe navigation routing manually
      this.handleGoBack();
    }
  }

  handleAutoSave=()=> {
    let stateChanged = JSON.stringify(this.state.messageDataOldState) !== JSON.stringify(this.state.messageData);
    let {messageData, messageDataOldState} = this.state;
    console.log('stateChanged: ', stateChanged, messageData.subject, messageDataOldState.subject);
    if(stateChanged){
      if(messageData.id){
        //messageData.subject !== '<p></p>\n' && 
        this.putMessagesById();
      }else// if((messageData.subject !== null && messageData.subject !== '<p></p>\n') || (messageData.body !== null && messageData.body !== '<p></p>\n'))
      {
        this.postMessages('Draft');
      };
    }
  }

  componentWillUnmount(){
    // if(this.props.showUtilityBillingMessages && window.location.href.includes('ub-step=billing-statements-sending')){
    //   document.getElementById("utility-message-draft").removeEventListener('click', this.handleAutoSave);
    //   document.getElementById("utility-message-draft-2").removeEventListener('click', this.handleAutoSave);
    // }
    //document.getElementById("utility-message-draft-3").removeEventListener('click', this.handleAutoSave);
    this.runAutoDeletionCheck();

    this.props.setCurrentMessagesData(null);

    window.removeEventListener('resize', this.handleResize);
    hideNotification('accountInformationIncompleteError');
    hideNotification('autoSaveMessageData');
    hideNotification('recipientsWithError');
    hideNotification('propertyAddressInformationIncomplete');
  }

  runAutoDeletionCheck=(keepalive=false)=>{
    const {messageType, templateId, replyAll, forward} = this.props;
    const {messageData, inPublishProcess, systemMessageTemplates} = this.state;
    console.log('runAutoDeletionCheck: ', messageData.templateType === 'RentalPayment', inPublishProcess === false,
    //messageData.body.replace(/\\/, '').replace('&nbsp;', ''), systemMessageTemplates.find((template)=> template.templateType === 'tenant-rent-message-template').body.replace(/\\/, '').replace('&nbsp;', ''),
    messageData?.subject?.replace(/\\/, '')?.replace('&nbsp;', '') === systemMessageTemplates.find((template)=> template.templateType === 'RentalPayment')?.subject?.replace(/\\/, '')?.replace('&nbsp;', ''));
    
    // if(messageData.templateType === 'RentalPayment' && inPublishProcess === false //&&
    // // messageData.body.replace(/\\/, '').replace('&nbsp;', '') === systemMessageTemplates.find((template)=> template.templateType === 'tenant-rent-message-template').body.replace(/\\/, '').replace('&nbsp;', '') &&
    // // messageData.subject.replace(/\\/, '').replace('&nbsp;', '') === systemMessageTemplates.find((template)=> template.templateType === 'tenant-rent-message-template').subject.replace(/\\/, '').replace('&nbsp;', '')
    // ){
    //   this.deleteMessagesById(messageData.id, true, keepalive);
    // }

    // if((messageType === 'TenantSignUp' || messageData.templateType === 'TenantSignUp') && inPublishProcess === false){
    //   this.deleteMessagesById(messageData.id, true, keepalive);
    // }
  }

  getPaymentDetails = () => {
    const userAccountID = this.props.profile.accountId;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + userAccountID + '/paymentMandate',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_account_payment_details',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_account_payment_details(response){
    if(response.status && response.statuscode === 200){
      this.setState({paymentDetails: response.result});
    }
  }

  getTemplateType=()=>{
    const {showUtilityBillingMessages, messageType, rentalPaymentId} = this.props;
    return showUtilityBillingMessages ? 'BillingStatement' : rentalPaymentId ? 'RentalPayment' : messageType === 'Tenant' ? 'Tenant' : messageType === 'TenantSignUp' ? 'TenantSignUp' : 'General'
  }

  // messages end-points start
  postMessages = (status, firstDraft=false) => {
    this.setState({messageSavingLoader: true, messageSavingStatusPopper: true});
    const {accountData, propertySelected, currentDataId, showUtilityBillingMessages, utilityBillingData, utilityBilling, draftMessageDetails, forward, replyAll, messageType, rentalPaymentId, accessLink, templateSubject, templateBody, templateId} = this.props;
    const messageData = (forward || replyAll) ? draftMessageDetails : this.state.messageData;
    const {defaultTemplate, systemMessageTemplates} = this.state;
    let currentBillingPeriod= showUtilityBillingMessages ? utilityBillingData.find((ub)=> ub.id === currentDataId)?.billingPeriod : null;
    console.log('currentBillingPeriod: ', currentBillingPeriod, currentDataId);
    console.log('defaultTemplate: ', defaultTemplate);
    
    let payload= {
      accountId: accountData?.accountId,
      propertyId: propertySelected.id,
      utilityBillingId: showUtilityBillingMessages ? currentDataId : null,
      
      // An explicitly supplied draft wins over every default. templateSubject/templateBody
      // mean "start from exactly this content" — the user picked a template, or the AI
      // assistant wrote one and opened this screen with it. Previously these were consulted
      // only at the very end of the chain, so for RentalPayment, TenantSignUp and
      // BillingStatement the system template silently replaced the content on the first
      // draft, and an account default template outranked a template the user had just
      // chosen by hand.
      subject: templateSubject ? templateSubject.replace(/\\/, '') :
      // Inject the default template check right at the beginning of the ternary equation
      defaultTemplate !== null ? defaultTemplate?.subject?.replace(/\\/, '') :
      (messageType === 'tenantRentMessage' && firstDraft) ? systemMessageTemplates.find((template)=> template.templateType === 'RentalPayment')?.subject?.replace(/\\/, '') :
      (messageType === 'TenantSignUp' && firstDraft) ?
      systemMessageTemplates.find((template)=> template.templateType === 'TenantSignUp')?.subject?.replace(/\\/, '')
      :
      showUtilityBillingMessages && firstDraft ? 
        // currentBillingPeriod ? 
        //   `<span>Betriebskostenabrechnung ${dayjs(currentBillingPeriod.startDate).format('DD.MM.YYYY')} - ${dayjs(currentBillingPeriod.endDate).format('DD.MM.YYYY')}</span>` 
        //   : 
          systemMessageTemplates.find((template)=> template.templateType === 'BillingStatement')?.subject?.replace(/\\/, '') 
      : (templateSubject || messageData?.subject || ""),
      
      body: templateBody ? templateBody.replace(/\\/, '')
      : defaultTemplate !== null  ? defaultTemplate?.body.replace(/\\/, '')
      : (messageType === 'tenantRentMessage' && firstDraft) ? systemMessageTemplates.find((template)=> template.templateType === 'RentalPayment')?.body?.replace(/\\/, '') : 
      (messageType === 'TenantSignUp' && firstDraft) ?
      systemMessageTemplates.find((template)=> template.templateType === 'TenantSignUp')?.body?.replace(/\\/, '')//.replace('<a href="#" target="_self">Zugangslink</a>', `<a href=\"${accessLink}\" target=\"_self\">${accessLink}</a>`)
      :
      replyAll ? "" : showUtilityBillingMessages && firstDraft ? systemMessageTemplates.find((template)=> template.templateType === 'BillingStatement')?.body?.replace(/\\/, '') : (templateBody || messageData?.body || ""),
      status,
      templateType: this.getTemplateType(),
      templateId: defaultTemplate !== null  ? defaultTemplate?.id : (templateId || undefined)
      //rentalPaymentId: rentalPaymentId
      //messageType: showUtilityBillingMessages ? 'utilityBilling' : rentalPaymentId ? 'rentDue' : 'all'
    };
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messages',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePostMessages',
      {payload, firstDraft},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handlePostMessages(response){
    const {messageType, recipients, showUtilityBillingMessages, setCurrentMessagesData} = this.props;
    const tenantId = this.props.history.location.state ? this.props.history.location.state.tenantId !== undefined ? this.props.history.location.state.tenantId : null : null;
    if(response.status && response.statuscode === 200){
      this.setState({messageData: response.result, messageDataOldState: response.result},()=> {
        response.result.subject && this.htmlToDraftConversion(response.result.subject);
        this.setState({messageSavingLoader: false}, ()=> setTimeout(() => {
          this.setState({messageSavingStatusPopper: false});
        }, 1000));
        !response.other.firstDraft && showNotification({
          message: 'Die Änderungen wurden übernommen.',
          icon: <img src={GreenTick} alt='green-tick'/>,
          id: 'autoSaveMessageData'
        })
      });
      if(showUtilityBillingMessages){
        this.postMessageRecipients(response.result.id, response.other.firstDraft);
      }
      if(recipients){
        this.postMessageRecipients(response.result.id, response.other.firstDraft);
      }
      if(messageType === 'tenantRentMessage'){
        this.postMessageRecipients(response.result.id, response.other.firstDraft);
      }
      if(messageType === 'TenantSignUp'){
        this.postMessageRecipients(response.result.id, response.other.firstDraft);
      }
      if(tenantId && messageType === 'General'){
        this.postMessageRecipients(response.result.id, response.other.firstDraft);
      }
      response.other.firstDraft && this.getMessagePostalFee();
      
      setCurrentMessagesData({...response.result, templateType: messageType === 'TenantSignUp' ? 'TenantSignUp' : response.result.templateType});
    }
  }

  postMessageRecipients=(messageId, firstDraft=false)=>{
    const {rentalPaymentId=null, messageType} = this.props;
    const recipientsFromProps = this.props.recipients;
    const {allRecipients, tenants} = this.state;
    const tenantId = this.props.history.location.state ? this.props.history.location.state.tenantId !== undefined ? this.props.history.location.state.tenantId : null : null;
    const multipleTenants = this.props.history.location.state ? this.props.history.location.state.multipleTenants !== undefined ? this.props.history.location.state.multipleTenants : [] : [];
    let tenantObject = (tenantId && firstDraft) ? tenants.find((tenant)=> tenant.id === tenantId) !== undefined ? tenants.find((tenant)=> tenant.id === tenantId) : null : null;
    let tenantsArray = (multipleTenants && firstDraft) ? tenants.filter((tenant)=> multipleTenants.find((mTenant)=> mTenant.userId === tenant.id) !== undefined) : null;
    //if(allRecipients.length > 0){
      console.log('tenantObject: ', tenantObject);
      console.log('recipientsFromProps: ', recipientsFromProps);

      console.log('testing343: ', tenantsArray.length > 0, tenantObject, firstDraft, allRecipients);
      
      
      let payload= 
      tenantsArray.length > 0 ?
      tenantsArray.map((tenant)=> {
        return {
          messageId,
          tenantId: tenant.id,
          //contactId,
          name: tenant?.isSecondaryAddressActive ? (tenant?.secondaryAddressName || tenant?.name) : tenant.name,
          email: tenant.email,
          street: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressStreet : tenant.street,
          zipCode: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressZipCode : tenant.zipCode,
          city: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressCity : tenant.city,
          isEmailEnabled: tenant.email ? true : tenant.isEmailEnabled,
          isPostEnabled: messageType === 'TenantSignUp' ? false : tenant?.isSecondaryAddressActive ? (tenant?.secondaryAddressStreet && tenant?.secondaryAddressZipCode && tenant?.secondaryAddressCity ? true : false) : (tenant.street && tenant.zipCode && tenant.city) ? true : tenant.isPostEnabled,
          isHiddenForTenantPortal: messageType === 'TenantSignUp' ? true : tenant.isHiddenForTenantPortal,
          rentalPaymentId
        };
      })
      :
      tenantObject ?
      [{
        messageId,
        tenantId: tenantObject.id,
        name: tenantObject?.isSecondaryAddressActive ? (tenantObject?.secondaryAddressName || tenantObject?.name) : tenantObject.name,
        email: tenantObject.email,
        street: tenantObject?.isSecondaryAddressActive ? tenantObject?.secondaryAddressStreet : tenantObject.street,
        zipCode: tenantObject?.isSecondaryAddressActive ? tenantObject?.secondaryAddressZipCode : tenantObject.zipCode,
        city: tenantObject?.isSecondaryAddressActive ? tenantObject?.secondaryAddressCity : tenantObject.city,
        isEmailEnabled: tenantObject.email ? true : tenantObject.isEmailEnabled,
        isPostEnabled: tenantObject?.isSecondaryAddressActive ? (tenantObject?.secondaryAddressStreet && tenantObject?.secondaryAddressZipCode && tenantObject?.secondaryAddressCity ? true : false) : (tenantObject.street && tenantObject.zipCode && tenantObject.city) ? true : tenantObject.isPostEnabled,
        isHiddenForTenantPortal: tenantObject.isHiddenForTenantPortal,
        rentalPaymentId
      }]
      :
      firstDraft ?
      recipientsFromProps?.length > 0 ? 
      recipientsFromProps.map((recipient)=> {
        return {
          messageId,
          tenantId: recipient?.tenantId,
          contactId: recipient?.contactId,
          name: recipient?.name,
          email: recipient?.email,
          street: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressStreet : recipient.street,//recipient?.street,
          zipCode: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressZipCode : recipient.zipCode,//recipient?.zipCode,
          city: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressCity : recipient.city,//recipient?.city,
          isEmailEnabled: recipient?.isEmailEnabled || false,
          isPostEnabled: recipient?.isSecondaryAddressActive ? ((recipient?.secondaryAddressStreet && recipient?.secondaryAddressZipCode && recipient?.secondaryAddressCity) ? true : false) : recipient?.isPostEnabled || false,
          isHiddenForTenantPortal: recipient?.isHiddenForTenantPortal || false,
          rentalPaymentId
        };
      })
      :
      tenants.map((tenant)=> {
        return {
          messageId,
          tenantId: tenant.id,
          //contactId,
          name: tenant?.isSecondaryAddressActive ? (tenant?.secondaryAddressName || tenant?.name) : tenant.name,
          email: tenant.email,
          street: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressStreet : tenant.street,
          zipCode: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressZipCode : tenant.zipCode,
          city: tenant?.isSecondaryAddressActive ? tenant?.secondaryAddressCity : tenant.city,
          isEmailEnabled: tenant.email ? true : tenant.isEmailEnabled,
          //isPostEnabled: (tenant.street && tenant.zipCode && tenant.city) ? true : tenant.isPostEnabled,
          isPostEnabled: tenant?.isSecondaryAddressActive ? ((tenant?.secondaryAddressStreet && tenant?.secondaryAddressZipCode && tenant?.secondaryAddressCity) ? true : false) : (tenant.street && tenant.zipCode && tenant.city) ? true : tenant.isPostEnabled,
          isHiddenForTenantPortal: tenant.isHiddenForTenantPortal,
          rentalPaymentId
        };
      })
      :
      allRecipients.map((recipient)=> {
        return {
          messageId,
          tenantId: recipient.id,
          //contactId,
          email: recipient.email,
          name: recipient?.isSecondaryAddressActive ? (recipient?.secondaryAddressName || recipient?.name) : recipient.name,
          street: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressStreet : recipient.street,
          zipCode: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressZipCode : recipient.zipCode,
          city: recipient?.isSecondaryAddressActive ? recipient?.secondaryAddressCity : recipient.city,
          isEmailEnabled: recipient.isEmailEnabled,
          isPostEnabled: recipient?.isSecondaryAddressActive ? ((recipient?.secondaryAddressStreet && recipient?.secondaryAddressZipCode && recipient?.secondaryAddressCity) ? true : false) : recipient.isPostEnabled,
          isHiddenForTenantPortal: recipient.isHiddenForTenantPortal,
          rentalPaymentId
        };
      });
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.user_reg_api_baseurl + 'messageRecipients',
        'POST',
        payload,
        null,
        false,
        true,
        false,
        this,
        'handlePostMessageRecipients',
        payload,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    //}
  }
  handlePostMessageRecipients(response){
    if(response.status && response.statuscode === 200){
      if(response.result.length > 0){
        let allRecipients = response.result.map((recipient)=> { 
          console.log('recipient.name: ', recipient.name);
          if(recipient.tenantId !== null){
            let ten = this.state.tenants.find((tenant)=> tenant.id === recipient.tenantId)
            if(ten !== undefined){
              return {...ten, ...recipient, id: recipient.id, name: recipient.name ? recipient.name : ten.name, value: recipient.id, label: recipient.name ? recipient.name : ten.name} 
            }else{
              // FIXED: Now correctly maps value to recipient.id
              return {...recipient, id: recipient.id, value: recipient.id, label: recipient.name} 
            }
          }else{
            // FIXED: Removed duplicate value declaration
            return {...recipient, id: recipient.id, value: recipient.id, label: recipient.name}
          }
        });
        this.setState({allRecipients, allRecipientsOldState: allRecipients, selectedRecipients: response.result.sort((a,b)=> a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase())).map((recipient)=> recipient.id)}, ()=> this.getMessagePostalFee());
      }
      //Todo: uncomment once backend changes implemented related to rentIcome messages.
      //this.props.history.replace({state: {}});
    }
  }

  putMessageRecipients=(messageId)=>{
    const {allRecipients} = this.state;
    if(allRecipients.length > 0){
      let payload= allRecipients.map((recipient)=> {
        return {
          ...recipient,
          messageId,
          tenantId: recipient.id,
          //contactId,
          name: recipient.name,
          isHiddenForTenantPortal: false,
          email: recipient.email,
          street: recipient.street,
          zipCode: recipient.zipCode,
          city: recipient.city,
          isEmailEnabled: recipient.isEmailEnabled,
          isPostEnabled: recipient.isPostEnabled
        };
      });
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.user_reg_api_baseurl + 'messageRecipients',
        'PUT',
        payload,
        null,
        false,
        true,
        false,
        this,
        'handlePutMessageRecipients',
        payload,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  }
  handlePutMessageRecipients(response){
    if(response.status && response.statuscode === 200){
      
    }
  }

  getMessageRecipientsByMessageId=(id)=>{
    const {messageData} = this.state;
    if(messageData.id){
      this.setState({messageRecipientsLoader: true});
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.user_reg_api_baseurl + 'messageRecipients?messageIds='+ id,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGettMessageRecipients',
        id,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        },
        true
      );
    }
  }

  handleGettMessageRecipients(response){
    console.log('handleGettMessageRecipients: ', response);
    const {allBillingStatements} = this.state;
    console.log('allBillingStatements: ', allBillingStatements);
    if(response.status && response.statuscode === 200){
      if(response.result.length > 0){
        let allRecipients = response.result.map((recipient)=> { 
          console.log('recipient.name: ', recipient.name);
          if(recipient.tenantId !== null){
            let ten = this.state.tenants.find((tenant)=> tenant.id === recipient.tenantId)
            if(ten !== undefined){
              return {...ten, ...recipient, id: recipient.id, name: recipient.name ? recipient.name : ten.name, value: recipient.id, label: recipient.name ? recipient.name : ten.name} 
            }else{
              // FIXED: Now correctly maps value to recipient.id
              return {...recipient, id: recipient.id, value: recipient.id, label: recipient.name} 
            }
          }else{
            // FIXED: Removed duplicate value declaration
            return {...recipient, id: recipient.id, value: recipient.id, label: recipient.name}
          }
        });
        if(allBillingStatements?.length > 0){
          let deleteRecipients = allRecipients.filter((recipient)=> allBillingStatements.find((billingStatement)=> recipient.tenantId === billingStatement.tenantId) === undefined);
          allRecipients = allRecipients.filter((recipient)=> allBillingStatements.find((billingStatement)=> recipient.tenantId === billingStatement.tenantId) !== undefined);
          deleteRecipients.forEach((recipient) => {
            this.deleteMessageRecipient(recipient?.id);
          });
        }
        this.setState({allRecipients, allRecipientsOldState: allRecipients, selectedRecipients: response.result.sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((recipient)=> recipient.id), messageRecipientsLoader: false}, ()=> this.getMessagePostalFee());
      }
    }
    // else if(response.statuscode === 429){
    //   this.setState({messageRecipientsLoader: true});
    //   setTimeout(() => {
    //     this.getMessageRecipientsByMessageId(response.other);  
    //   }, 3000);
      
    // }
    else if(response.statuscode !== 429){
      this.setState({messageRecipientsLoader: false}, ()=> this.getMessagePostalFee());
    }
  }

  deleteMessageRecipient=(id)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messageRecipients/'+ id,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteMessageRecipients',
      {id},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleDeleteMessageRecipients(response){
    if(response.status && response.statuscode === 200){

    }
  }

  updateRecipient=(recipientData)=>{
    let payload = recipientData;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messageRecipients/'+ recipientData.id,
      'PUT',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePutMessageRecipients',
      payload,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handlePutMessageRecipients(response){

  }

  getUBMessagesByUtilityBillingId = () => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + `messages/GetAllByUtilityBilling?utilityBillingId=${this.props.currentDataId}&messageStatus=Draft`,//GetAllByAccount
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetMessages',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleGetMessages(response){
    const {messageType, setCurrentMessagesData} = this.props;
    if(response.status && response.statuscode === 200){
      if(response.result.length > 0){
        let messageData= response.result[0];//.find((msgDt)=> msgDt.utilityBillingId === this.props.currentDataId);
        if(messageData){
          this.setState({messageData, messageDataOldState: messageData},()=> {
            messageData.subject && this.htmlToDraftConversion(messageData.subject);
            this.getBillingStatements(()=> this.getMessageRecipientsByMessageId(messageData.id));
          });
        }
      }
      setCurrentMessagesData({...response.result, templateType: messageType === 'TenantSignUp' ? 'TenantSignUp' : response.result.templateType});
    }else if(response.message === 'Not Found'){
      console.log('handleGetMessages: ', response);
      this.getMessageTemplates();
      //this.postMessages('Draft', true);
    }
  }

  handleGetTemplates(response){
    //if(response.status && response.statuscode === 200){
      const data = response?.result;
      if(data.length > 0){
         this.setState({messageTemplates: data.map((template)=> ({...template, body: template?.body?.replaceAll('\n', '').replaceAll('&nbsp;', ''), subject: template?.subject?.replaceAll('\n', '').replaceAll('&nbsp;', '')}))});
      }
      if(response?.other?.updateOnlyTemplatesList){
        return;
      }
      console.log('tesag; ', this.getTemplateType());
      
      const filterTemplate = data.filter((template)=> template.templateType === this.getTemplateType());
      if(filterTemplate.length > 0){
        let findDefaultTemplate = filterTemplate.find((template)=> template?.isDefaultTemplate);
        if(findDefaultTemplate !== undefined && findDefaultTemplate !== null){
          this.setState({defaultTemplate: findDefaultTemplate}, ()=> this.postMessages('Draft', true));
        }else{
          this.setState({defaultTemplate: null}, ()=> this.postMessages('Draft', true));
        }
      }else{
          this.setState({defaultTemplate: null}, ()=> this.postMessages('Draft', true));
      }
    //}
  }

  getMessagesById = (id) => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_api_baseurl + '/messages/'+id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetMessagesById',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handleGetMessagesById(response){
    if(response.status && response.statuscode === 200){

    }
  }

  putMessagesById = () => {
    this.setState({messageSavingLoader: true, messageSavingStatusPopper: true});
    let payload= this.state.messageData;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messages/'+this.state.messageData.id,
      'PUT',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePutMessagesById',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handlePutMessagesById(response){
    const {messageType, setCurrentMessagesData} = this.props;
    if(response.status && response.statuscode === 200){
      this.setState({messageData: response.result, messageDataOldState: response.result}, ()=> {
        this.setState({messageSavingLoader: false}, ()=> setTimeout(() => {
          this.setState({messageSavingStatusPopper: false});
        }, 1000));
        // showNotification({
        //   message: 'Die Änderungen wurden übernommen.',
        //   icon: <img src={GreenTick} alt='green-tick'/>,
        //   id: 'autoSaveMessageData'
        // });
        if(this.state.allRecipients.length > 0){
          //this.putMessageRecipients(response.result.id);
        }else{
          //this.postMessageRecipients(response.result.id);
        }
      });

      setCurrentMessagesData({...response.result, templateType: messageType === 'TenantSignUp' ? 'TenantSignUp' : response.result.templateType});
    }
  }

  replaceAllPlaceHolders=(html)=>{
    let newHtml= html;

    newHtml= newHtml.replaceAll('<a href="#" target="_self">Abrechnungszeitraum</a>', '{{TENANT_OCCUPATION_BILLING_PERIOD}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Betriebskosten</a>', '{{TOTAL_ALLOCATED_UTILITY_COSTS}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Guthaben / Nachzahlung</a>', '{{BILLING_STATEMENT_BALANCE}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Empfänger</a>', '{{RECIPIENT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Mieteinheit</a>', '{{RENTAL_UNIT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Objektadresse</a>', '{{PROPERTY_STREET}}, {{PROPERTY_ZIPCODE}} {{PROPERTY_CITY}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Vorauszahlungen</a>', '{{TOTAL_ADVANCE_PAYMENTS}}');

    //new
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Mieter</a>', '{{TENANT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Absender</a>', '{{USER_FIRST_NAME}} {{USER_LAST_NAME}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Auszugsdatum</a>', '{{TENANT_MOVE_OUT_DATE}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Einzugsdatum</a>', '{{TENANT_MOVE_IN_DATE}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">erhaltene Miete</a>', '{{RENTAL_PAYMENT_RECEIVED_RENT}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">gesamte ausstehende Miete</a>', '{{RENTAL_PAYMENT_EXPECTED_RENT_TOTAL}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Kaltmiete</a>', '{{COLD_RENT}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Mietmonat</a>', '{{RENTAL_PAYMENT_MONTH}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Vermieter</a>', '{{ACCOUNT_COMPANY_NAME}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Vorauszahlung</a>', '{{RENT_PRE_PAYMENTS}}');
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Warmmiete</a>', '{{WARM_RENT}}');

    newHtml= newHtml.replaceAll('<a href="#" target="_self">Zugangslink</a>', `https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`);
    newHtml= newHtml.replaceAll('<a href="#" target="_self">Eigentümer</a>', '{{PROPERTY_OWNER_NAME}}');
    
    
    newHtml= newHtml.replaceAll('<a href="" target="_self">Abrechnungszeitraum</a>', '{{TENANT_OCCUPATION_BILLING_PERIOD}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Betriebskosten</a>', '{{TOTAL_ALLOCATED_UTILITY_COSTS}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Guthaben / Nachzahlung</a>', '{{BILLING_STATEMENT_BALANCE}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Empfänger</a>', '{{RECIPIENT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Mieteinheit</a>', '{{RENTAL_UNIT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Objektadresse</a>', '{{PROPERTY_STREET}}, {{PROPERTY_ZIPCODE}} {{PROPERTY_CITY}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Vorauszahlungen</a>', '{{TOTAL_ADVANCE_PAYMENTS}}');

    //new
    newHtml= newHtml.replaceAll('<a href="" target="_self">Mieter</a>', '{{TENANT_NAME}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Absender</a>', '{{USER_FIRST_NAME}} {{USER_LAST_NAME}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Auszugsdatum</a>', '{{MOVE_OUT_DATE}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Einzugsdatum</a>', '{{MOVE_IN_DATE}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">erhaltene Miete</a>', '{{RENTAL_PAYMENT_RECEIVED_RENT}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">gesamte ausstehende Miete</a>', '{{RENTAL_PAYMENT_EXPECTED_RENT_TOTAL}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Kaltmiete</a>', '{{COLD_RENT}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Mietmonat</a>', '{{RENTAL_PAYMENT_MONTH}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Vermieter</a>', '{{ACCOUNT_COMPANY_NAME}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Vorauszahlung</a>', '{{RENT_PRE_PAYMENTS}}');
    newHtml= newHtml.replaceAll('<a href="" target="_self">Warmmiete</a>', '{{WARM_RENT}}');

    newHtml= newHtml.replaceAll('<a href="" target="_self">Zugangslink</a>', `https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`);
    newHtml= newHtml.replaceAll('<a href="" target="_self">Eigentümer</a>', '{{PROPERTY_OWNER_NAME}}');

    console.log('newMessageData: ', newHtml);
    //setNewMessageBody(newHtml);
    return newHtml;
  }

  putPublishMessagesById = () => {
    let payload= this.state.messageData;
    payload.body= this.replaceAllPlaceHolders(payload.body.replaceAll('\n', '').replaceAll('&nbsp;', '').replaceAll('#disabled', '#'));
    payload.subject= this.replaceAllPlaceHolders(payload.subject.replaceAll('\n', '').replaceAll('&nbsp;', '').replaceAll('#disabled', '#'));
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messages/'+this.state.messageData.id,
      'PUT',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handleFinalPutMessagesById',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handleFinalPutMessagesById(response){
    if(response.status && response.statuscode === 200){
      this.getMessagePostalFee();
      var elem = document.getElementById("publishMessage");
      this.props.setPublishMessageId(this.state.messageData.id);
      loader(true);
      setTimeout(() => {
        if (typeof elem.onclick == "function") {
          elem.onclick.apply(elem);
          this.setState({inPublishProcess: true});
          showNotification({
            message: 'Der Versandprozess wurde gestartet.',
            icon: <img src={GreenTick} alt='green-tick'/>
          });
          this.props.setUtilityBillingData([]);
          loader(false);
          this.props.history.push('/messaging');
        }  
      }, 1000);
      // Autoload.HttpRequestAxios.HttpRequest(
      //   Autoload.Setting.user_reg_api_baseurl + 'messages/'+this.state.messageData.id+'/publish',
      //   'PUT',
      //   null,
      //   null,
      //   false,
      //   true,
      //   false,
      //   this,
      //   'handlePutPublishMessagesById',
      //   null,
      //   false,
      //   '',
      //   {
      //     Authorization: Autoload.Utils.getAuthToken(),
      //   }
      // );
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='green-tick'/>
      });
      this.setState({openMessageConfirmationModal: false});
    }
  }

  handlePutPublishMessagesById(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Der Versandprozess wurde gestartet.',
        icon: <img src={GreenTick} alt='green-tick'/>
      });
      this.props.setUtilityBillingData([]);
      this.props.history.push('/messaging');
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='green-tick'/>
      });
    }
    this.setState({openMessageConfirmationModal: false});
  }

  deleteMessagesById = (id, stopGoBackToMessages=false, keepalive=false) => {
    if(keepalive){
      fetch(Autoload.Setting.user_reg_api_baseurl + 'messages/'+id, {
      method: 'DELETE',
      keepalive: true, 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Autoload.Utils.getAuthToken()
      }
    });
    }else{
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.user_reg_api_baseurl + 'messages/'+id,
        'DELETE',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleDeleteMessagesById',
        {stopGoBackToMessages},
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    }
  };

  handleDeleteMessagesById(response){
    if(response.status && response.statuscode === 200){
      if(window.location.href.includes('ub-step=billing-statements-sending')){
        this.props.goBack();
      }else if(response.other.stopGoBackToMessages === false){
        this.props.history.push('/messaging');
      }
      
    }
  }

  getMessagePostalFee=()=>{
    const {numberBillingStatementTableRows, numberMeterReadingsTableRows, showUtilityBillingMessages, utilityBillingData, currentDataId} = this.props;
    let ub = utilityBillingData?.find((ub)=> ub.id === currentDataId);
    console.log('getMessagePostalFee_ub: ', ub);
    let billingStatementRows = numberBillingStatementTableRows ? numberBillingStatementTableRows : this.state.numberBillingStatementTableRows;
    let billingStatementPages = showUtilityBillingMessages ? (billingStatementRows > 32 ? (Math.ceil((billingStatementRows - 32)/44) + 1) : 1) : 0;
    let meterReadingsPages = showUtilityBillingMessages ? !ub?.isMeterReadingAndConsumptionInfoHidden ? (numberMeterReadingsTableRows > 44 ? (Math.ceil((numberMeterReadingsTableRows - 44)/44) + 1) : 1) : 0 : 0;
    let heatingInformationPages = showUtilityBillingMessages ? ub?.heatingCostsActivated ? (!ub?.isCostSplitWarmWaterAndHeatingCostInfoHidden || !ub?.isHeatingCostInfoHidden || !ub?.isSplitBaseConsumptionCostInfoHidden) ? 1 : 0 : 0 : 0;
    
    console.log('getMessagePostalFee: ', billingStatementPages, meterReadingsPages);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.user_reg_api_baseurl + 'messages/'+ this.state.messageData.id+'/PostalFee?pageCount='+ (billingStatementPages+meterReadingsPages+heatingInformationPages+1),
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetMessagePostalFee',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handleGetMessagePostalFee(response){
    if(response.status && response.statuscode === 200){
      this.setState({postalFee: response.result});
    }
  }
  // messages end-points end
  // postal top-up start
  putTopUpCredit=(amount)=>{
    loader(true);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + `${this.props.accountData.accountId}/rechargePostalFee?amount=${amount}`,
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handlePutTopUpCredit',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handlePutTopUpCredit(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Das neue Guthaben wurde Ihrem Portoguthaben gutgeschrieben.',
        icon: <img src={GreenTick} alt='green-tick' />,
        id: 'postalTopUpSuccess'
      });
      this.getAccounts();
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross' />,
        id: 'postalTopUpError'
      });
    }
    loader(false);
    this.setState({openMessagingPricingModal: false});
  }

  getAccounts=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.account_api_baseurl + this.props.accountData.accountId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetAccounts',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }
  handleGetAccounts(response){
    if(response.status && response.statuscode === 200){
      this.props.setAccountData(response.result);
    }
  }
  // postal top-up end
  htmlToDraftConversion=(data)=>{
    // 1. Check if external tenants exist in the current recipient list
    const {allRecipients} = this.state;
    const externalTenantFound = allRecipients.find((recipient)=> recipient?.tenantId === null) !== undefined;
    
    // 2. Format the string appropriately
    data = externalTenantFound ? this.disableAllTenantPlaceholdersInsideSubject(data) : this.revertDisableAllTenantPlaceholdersInsideSubject(data);

    const contentBlock = htmlToDraft(data);
    if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState1 = EditorState.createWithContent(contentState);
        const editorState2 = EditorState.moveFocusToEnd(editorState1);
        this.onEditorStateChange(editorState2);
        return 'handled';
    }
  }

  onEditorStateChange = (editorState) => {
    // 1. Get the raw HTML from the editor
    let rawHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    
    // 2. Clean it to ensure we don't save #disabled to the DB or state
    let cleanHtml = this.revertDisableAllTenantPlaceholdersInsideSubject(rawHtml);

    this.setState({
      editorState, 
      messageData: {
        ...this.state.messageData, 
        subject: cleanHtml // Save the clean version
      }
    });
  };

  // The body lives in MessagingEditor's own Draft.js state, and that component only re-reads
  // the `body` prop when it goes from null to set (see its componentDidUpdate) — so a prop
  // change can't push a new body into an editor that already has one. This ref is how the AI
  // result reaches it: htmlToDraftConversion is the same entry point the initial load and the
  // template picker use, and it runs the placeholder enable/disable pass and the debounced
  // autosave on the way through.
  messagingEditorRef = React.createRef();

  // Placeholders the AI is allowed to use: exactly the ones this message's own placeholder
  // popover would offer, minus the tenant-specific ones that an external recipient makes
  // unresolvable. Anything wider would produce a placeholder that silently resolves to
  // nothing when the message is sent.
  getAiAllowedPlaceholders = () => {
    const {placeholders} = this.props;
    const {allRecipients} = this.state;
    return getAvailablePlaceholderLabels(placeholders, {
      externalRecipientPresent: allRecipients.find((recipient)=> recipient?.tenantId === null) !== undefined
    });
  }

  // Writes a generated message into the editor. Subject and body are separate editors, so
  // they're set through their own conversion paths; both then autosave the way a typed
  // change would. This overwrites whatever was there, which is why the modal confirms first.
  applyAiGeneratedMessage = ({subject, body}) => {
    if(subject){
      this.htmlToDraftConversion(subject);
    }
    if(body){
      if(this.messagingEditorRef.current){
        this.messagingEditorRef.current.htmlToDraftConversion(body);
      }else{
        // The editor is only absent if the message hasn't rendered yet; keep the generated
        // text rather than dropping it silently.
        this.setState({messageData: {...this.state.messageData, body}}, ()=> this.handleAutoSave());
      }
    }
    showNotification({
      message: 'Die Nachricht wurde übernommen.',
      icon: <img src={GreenTick} alt='green-tick'/>,
      id: 'ai-message-assistant-applied'
    });
  }

  addPlaceHolderToSubject = (html) => {
    const { editorState } = this.state;
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    const contentBlock = htmlToDraft(html);
    
    if (contentBlock) {
        const newContent = Modifier.replaceWithFragment(
          currentContent,
          currentSelection,
          ContentState.createFromBlockArray(contentBlock.contentBlocks).getBlockMap()
        );
        
        const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
        
        // Fix: Force the editor to retain focus at the end of the newly inserted fragment
        const focusedEditorState = EditorState.forceSelection(
          newEditorState, 
          newContent.getSelectionAfter()
        );
        
        this.onEditorStateChange(focusedEditorState);
    }
  }

  getBillingStatements=(callBackFunction=()=> null)=>{
    this.setState({loader: true});
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'billingStatements?utilityBillingId='+this.props.currentDataId,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetBillingStatements',
        {callBackFunction},
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
    );
  }

  handleGetBillingStatements(response){
    if(response.status && response.statuscode === 200){
        this.setState({allBillingStatements: response.result});
        if(response.result.length > 0){
          this.getCostAllocationsForBillingStatements(response.result[0].id);
        }
    }

    response.other.callBackFunction();
  }

  

  getCostAllocationsForBillingStatements=(id)=>{
    Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.ub_api_base_url + 'costAllocations/forBillingStatement?utilityBillingId='+this.props.currentDataId+'&billingStatementId='+id,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetCostAllocationsForBillingStatements',
        null,
        false,
        '',
        {
          Authorization: Autoload.Utils.getAuthToken(),
        }
    );
  }

  handleGetCostAllocationsForBillingStatements(response){
    if(response.status && response.statuscode === 200){
        this.setState({numberBillingStatementTableRows: response.result.length}, ()=> this.getMessagePostalFee());
    }
  }
  
  sendMessageEvent=()=> {
    const {allRecipients, messageData, postalFee, isMobile, senderInfo} = this.state;
    const {accountData, propertySelected} = this.props;
    const senderInfoReroute = (propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled) ? '/property/propertyOwnerInformation' : '/profile/companyDetails';
    if(allRecipients.length === 0){
      showNotification({
        message: 'Bitte wählen Sie mindestens einen Empfänger aus, um fortzufahren.', 
        icon: <img src={RedCross} />
      })
    }else if(!senderInfo?.name || !senderInfo?.street || !senderInfo?.postalCode || !senderInfo?.city || !senderInfo?.email){ //|| !senderInfo?.phoneNumber
      showNotification({
        message: <span>Die Absenderinformationen oder Absender-E-Mail ist unvollständig. Bitte ergänzen Sie die Kontaktdaten im <span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> this.props.history.push(senderInfoReroute)}>Nutzerkonto</span>.</span>,
        icon: <img src={RedCross} alt='red-cross' />,
        autoClose: false,
        id: 'accountInformationIncompleteError'
      });
    }
    else if((messageData.body.includes('<a href="#" target="_self">Objektadresse</a>') || messageData.body.includes('<a href="" target="_self">Objektadresse</a>') || messageData.subject.includes('<a href="#" target="_self">Objektadresse</a>') || messageData.subject.includes('<a href="" target="_self">Objektadresse</a>')) && (!propertySelected.propertyAddress || !propertySelected.propertyCity || !propertySelected.propertyZipCode)){
      showNotification({
        message: 
        <div>
          <div><span>Die Informationen für den Platzhalter Objektadresse sind noch nicht vollständig. Bitte ergänzen Sie die Informationen oder entfernen Sie den Platzhalter.</span></div>
          <div><span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> this.props.history.push('/property')}>Objektadresse ergänzen</span><img src={RightArrowPartner} style={{width: '12px', marginLeft: '4px'}}/></div>
        </div>,
        icon: <img src={RedCross} alt='red-cross' />,
        autoClose: false,
        id: 'propertyAddressInformationIncomplete'
      });
    }else if(accountData.accountPostalCredit < postalFee.totalPostalFee){
      showNotification({
        message: <span>Ihr aktuelles Portoguthaben reicht nicht aus, um diese Nachricht zu versenden. Bitte laden Sie Ihr Portoguthaben auf. <span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> this.setState({openMessagingPricingModal: true}, ()=> hideNotification('creditAmountLessThanExpectedAmountError'))}>Portoguthaben aufladen<img src={RightArrowPartner} style={{width: '12px', marginLeft: '4px'}}/></span></span>,
        icon: <img src={RedCross} alt='red-cross' />,
        id: 'creditAmountLessThanExpectedAmountError'
      })
    }
    else{
      console.log('allRecipient_senden: ', allRecipients);
      let recipientsWithError = allRecipients.filter((recipient)=> recipient.isEmailEnabled === false && recipient.isPostEnabled === false && recipient.isHiddenForTenantPortal === true)
      if(recipientsWithError.length > 0){
        showNotification({
          message: 
          <Stack gap={0}>
            <span>{`Bitte wählen Sie für die nachfolgenden Empfänger mindestens eine Versandmethode (Email, Brief, Mieterportal) aus, um fortzufahren: ${recipientsWithError.sort((a,b)=> a.name.localeCompare(b.name)).map((recipient, index)=> ` ${recipient.name}`)}`}</span>
          </Stack>,
          icon: <img src={RedCross} alt='red-cross'/>,
          id: 'recipientsWithError'
        })
      }else{
        this.setState({openMessageConfirmationModal: true});
      }
    }
  }
  renderSendButton=()=>{
    const {allRecipients, messageData, postalFee, isMobile, senderInfo} = this.state;
    const {accountData, propertySelected, loadingUbData=false} = this.props;
    return (
      <Skeleton visible={loadingUbData}>
        <ColorButton
        text={'Senden'}
        className={`purple-btn ${(allRecipients.length === 0 || !senderInfo?.name || !senderInfo?.street || !senderInfo?.postalCode || !senderInfo?.city || !senderInfo?.email) && 'disabled'}`}
        onClick={()=> this.sendMessageEvent()}
        />
      </Skeleton>
    )
  }

  renderAccountMessageBalanceAndEstimation=()=>{
    const {postalFee, openPostalFeeStatus, isMobile, hoverOnStarter2} = this.state;
    const {accountData, currentSubscription, loadingUbData=false} = this.props;
    console.log('loadingUbData: ', loadingUbData);
    return(
      <Stack align={isMobile ? 'flex-start' : 'flex-end'} gap={3} style={{marginRight: '2px', marginTop: !isMobile && '13.5px'}}>
        {isMobile && <lable>Portokosten</lable>}
        { <Popover
  opened={Boolean(postalFee && openPostalFeeStatus)}
  withArrow
  // 1. Combine placement and position dynamically
  position={isMobile ? 'bottom-start' : 'left-start'}
  // 2. Catch click-outside events for mobile users
  onChange={(opened) => {
    if (!opened) this.setState({ openPostalFeeStatus: false });
  }}
>
  {/* 3. Target Wrapper */}
  <Popover.Target>
    <Group 
      wrap="nowrap" 
      style={{ fontWeight: '400', color: '#13135C', fontSize: '12px', cursor: 'pointer' }}
      onMouseEnter={() => this.setState({ openPostalFeeStatus: true })} 
      onMouseLeave={() => this.setState({ openPostalFeeStatus: false })}
      onTouchStart={() => this.setState({ openPostalFeeStatus: !openPostalFeeStatus })}
    >
      Voraussichtliche Portokosten: {postalFee ? checkProperty(postalFee, 'totalPostalFee', null) ? formatNumber(postalFee.totalPostalFee, true) : '0,00 €' : '0,00 €'}
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="xs">
    {postalFee && (
      <Group style={{ width: '250px', fontSize: '12px', fontWeight: '400' }}>
        <span>
          <span style={{ fontWeight: 'bold' }}>
            Voraussichtliche Portokosten: {postalFee ? checkProperty(postalFee, 'totalPostalFee', null) ? formatNumber(postalFee.totalPostalFee, true) : '0,00 €' : '0,00 €'}
          </span>
          <br />
          ({postalFee.recipientCount} {postalFee.name === 'Standard Letter' ? 'Standard-Briefe' : postalFee.name === 'Compact Letter' ? 'Kompakt-Briefe' : postalFee.name === 'Large Letter' ? 'Groß-Briefe' : ''}{postalFee.additionalPageCount > 0 && ` mit ${postalFee.additionalPageCount} Zusatzseite(n) je ${formatNumber(postalFee.fee, true)}`}).
          <br />
          Die tatsächlichen Portokosten werden bei Übermittlung an die Deutsche Post ermittelt.
        </span>
      </Group>
    )}
  </Popover.Dropdown>
</Popover>}
        
        <Group wrap="nowrap" style={{fontWeight: '400', color: '#13135C', fontSize: '12px'}}>Portoguthaben: {accountData ? checkProperty(accountData, 'accountPostalCredit', null) ? formatNumber(accountData.accountPostalCredit, true) : '0,00 €' : '0,00 €'}</Group>
        <Group wrap="nowrap" style={{fontSize: '12px', fontWeight: '400', color: '#5555FF', cursor: 'pointer'}} gap={5} onClick={()=> !loadingUbData && this.setState({openMessagingPricingModal: true})}><Skeleton visible={loadingUbData}>Portoguthaben aufladen <img src={RightArrowPartner} style={{marginTop: '-2px', width: '12px'}}/></Skeleton></Group>
      </Stack>
    )
  }

  renderMessagingButtons=()=>{
    const {allRecipients, messageData, postalFee, openPostalFeeStatus, isMobile, hoverOnStarter2, messageTemplates} = this.state;
    const {accountData, propertySelected, currentSubscription, loadingUbData=false} = this.props;
    let templateInUse = messageTemplates?.length > 0 ? messageTemplates.find((template)=> template?.id === messageData?.templateId) : undefined;
    console.log('templateInUse: ', templateInUse);
    
    return(
      <Stack align={'flex-end'} gap={5}>
        <Group gap={10} wrap="nowrap">
          <Group gap={5} wrap="nowrap">
            <div>
              {isMobile ?
              <Group wrap="nowrap" gap={8} align="center">
                <Skeleton visible={loadingUbData}>
                  <RecordOptions
                  showEditButton={false}
                  showDeleteButton={false}
                  listOfItems={[
                      {
                        text: <span style={{color: '#E8193C'}}>Löschen</span>,
                        className: 'receipts-main-menu-dropdown-item',
                        leftImage: <DeleteIcon style={{fontSize: '15px', color: '#E8193C'}}/>,
                        openFunction: (()=> this.setState({openMessageDeletionModal: true}))
                      },
                      {
                        text: 'Alle herunterladen',
                        className: 'receipts-main-menu-dropdown-item',
                        leftImage: <img src={PdfIcon} width={'15px'} />,
                        openFunction: (()=> this.setState({openBulkMessageDownloadModal: true}))
                      }
                  ]}
                  style={{marginRight: '0px'}}
                  buttonStyle={{border: 'none', background: 'transparent'}}
                  />
                </Skeleton>
                {/* Same buttons as desktop: Vorschau and Senden next to the menu */}
                <Skeleton visible={loadingUbData}>
                  <ColorButton
                  text={'Vorschau'}
                  className={'gray-btn'}
                  onClick={()=> this.setState({openPreviewModal: true})}
                  disabled={allRecipients.length === 0}
                  />
                </Skeleton>
                {this.renderSendButton()}
              </Group>
              :
              <RecordOptions
              // className="delete-message"
              // showEditButton={false}
              // toggleDeleteModal={() => this.setState({openMessageDeletionModal: true})}
              // showLockButton={false}
              // //showPrintButton={messageData.utilityBillingId !== null}
              // //onPrint={()=> this.setState({openBulkMessageDownloadModal: true})}
              // //printButtonText={'Alle herunterladen (PDF)'}
              // buttonStyle={{background: 'none', border: 'none', minWidth: '37px'}}
              showEditButton={false}
              showDeleteButton={false}
              listOfItems={[
                  {
                    text: <span style={{color: '#E8193C'}}>Löschen</span>,
                    className: 'receipts-main-menu-dropdown-item',
                    leftImage: <DeleteIcon style={{fontSize: '15px', color: '#E8193C'}}/>,
                    openFunction: (()=> this.setState({openMessageDeletionModal: true}))
                  },
                  {
                    text: 'Vorlage zurücksetzen',
                    className: 'receipts-main-menu-dropdown-item',
                    leftImage: <img src={ResetIcon} width={'15px'} />,
                    openFunction: (()=> templateInUse !== undefined && TemplateServices.deleteTemplate(this, 'handleDeleteTemplate', null, templateInUse?.id)),
                    disabled: templateInUse === undefined
                  }
              ]}
              style={{marginRight: '0px'}}
              buttonStyle={{border: 'none', background: 'transparent'}}
              />}
            </div>
            {!isMobile &&
            <div>
              <Skeleton visible={loadingUbData}>
                <ColorButton
                text={'Vorschau'}
                className={'gray-btn'}
                onClick={()=> this.setState({openPreviewModal: true})}
                disabled={allRecipients.length === 0}
                />
              </Skeleton>
            </div>}
          </Group>
          <div>
            {!isMobile && this.renderSendButton()}
          </div> 
          {/* <Group>
            <Tooltip title="Drucken">
              <IconButton 
              aria-label="filter list" 
              onClick={() => null}
              style={{
                background: 'white', 
                border: '1px solid #DADAE5', 
                boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                padding: '5px'
                }}>
                <img
                src={PrintIconBlue} 
                style={{
                  width: '15px',
                  height: '15px',
                  }}/>
              </IconButton>
            </Tooltip>
          </Group> */}
        </Group>
        
        {!isMobile && this.renderAccountMessageBalanceAndEstimation()}
      </Stack>
    )
  }

  handleDeleteTemplate(response){
    if(response.status && response.statuscode === 200){
      if(this.state.messageData?.templateId){
        this.setState({messageData: {...this.state.messageData, templateId: null}}, ()=> this.putMessagesById());
      }
      this.getMessageTemplates({updateOnlyTemplatesList: true});
      showNotification({
        message: 'Die Vorlage wurde zurückgesetzt.',
        icon: <img src={GreenTick} alt='green-tick' />
      });
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross' />
      });
    }
  }

  evaluateRentalPayments=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/evaluateRentalPayments',
      'POST',
      {propertyId: this.props.propertySelected.id},
      null,
      false,
      true,
      false,
      this,
      'handleEvaluateRentalPayments',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleEvaluateRentalPayments(response){
    this.putPublishMessagesById();
  }

  getMessageTemplates=(other=null)=> TemplateServices.getTemplates(this, 'handleGetTemplates', other, this.props)

  handleGoBack = () => {
    // 1. Close the modals
    this.setState({ openMessageDeletionModal: false, confirmMessageDeletionModal: false });

    // 2. Fetch required routing data
    const { messageData } = this.state;
    const previousUrl = this.props.history.location.state ? this.props.history.location.state.previousUrl : null;

    // 3. Trigger the loader and navigate based on the template type
    loader(true);
    setTimeout(() => {
      loader(false);
      
      if (messageData?.templateType === 'RentalPayment') {
        if (previousUrl) {
          this.props.history.push(previousUrl, { comingFromRoute: 'messages', open: 'rentIncomeTracking' });
        } else {
          this.props.history.push('/user/rentIncomeTracking');
        }
      } else if (messageData?.templateType === 'TenantSignUp') {
        this.props.history.push('/tenantPortal');
      } else {
        if (previousUrl) {
          this.props.history.push(previousUrl, { comingFromRoute: 'messages', open: 'messages' });
        } else {
          this.props.history.push('/messaging');
        }
      }
    }, 600);
  };

  getCharacterCount = (editorState) => {
    // getPlainText('') gets the raw string without HTML tags
    const plainText = editorState.getCurrentContent().getPlainText('');
    return plainText.length;
  };

  handleSubjectBeforeInput = (chars, editorState) => {
    const charCount = this.getCharacterCount(editorState);
    const isCollapsed = editorState.getSelection().isCollapsed();
    console.log('charCount: ', charCount, 'isCollapsed: ', isCollapsed);
    
    // If character limit is reached and the user isn't replacing currently highlighted text
    if (charCount >= 1000 && isCollapsed) {
      this.subjectCharacterLimitError();
      return 'handled'; // Tells Draft.js to block the input
    }
    return 'not-handled'; // Allows the input
  };

  handleSubjectPastedText = (pastedText, html, editorState) => {
    // 1. Clean the text: Replace carriage returns and newlines with a single space
    const cleanedText = pastedText.replace(/[\r\n]+/g, ' ');

    const currentCharCount = this.getCharacterCount(editorState);
    const pastedCharCount = cleanedText.length;

    // Prevent pasting if the combined characters exceed the limit
    if (currentCharCount + pastedCharCount > 1000) {
      this.subjectCharacterLimitError();
      return 'handled'; // Tells Draft.js to block the paste
    }

    // 2. Get current state and selection
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    // 3. Manually insert the cleaned text at the current cursor/selection
    const newContent = Modifier.replaceText(
      currentContent,
      selection,
      cleanedText
    );

    // 4. Push the new state to the Editor
    const newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
    this.onEditorStateChange(newEditorState);

    // 5. Tell Draft.js we've fully handled the paste event natively
    return 'handled';
  };

  subjectCharacterLimitError=() => {
    showNotification({
      message: 'Es ist ein Fehler aufgetreten: Betreffzeile zu lang.',
      icon: <img src={RedCross} alt='red-cross'/>,
      id: 'subjectCharacterLimitError'
    });
  }

  disableAllTenantPlaceholdersInsideSubject = (data) => {
    if (!data) return data;
    const placeholders = ['Auszugsdatum', 'Einzugsdatum', 'erhaltene Miete', 'gesamte ausstehende Miete', 'Kaltmiete', 'Mieter', 'Mieteinheit', 'Mietmonat', 'Vorauszahlung', 'Warmmiete'];
    
    let modifiedData = data;
    placeholders.forEach(ph => {
      modifiedData = modifiedData.replaceAll(`<a href="#" target="_self">${ph}</a>`, `<a href="#disabled" target="_self">${ph}</a>`);
      modifiedData = modifiedData.replaceAll(`<a href="#" class="rdw-mention-link">${ph}</a>`, `<a href="#disabled" class="rdw-mention-link">${ph}</a>`);
    });
    return modifiedData;
  }

  revertDisableAllTenantPlaceholdersInsideSubject = (data) => {
    if (!data) return data;
    const placeholders = ['Auszugsdatum', 'Einzugsdatum', 'erhaltene Miete', 'gesamte ausstehende Miete', 'Kaltmiete', 'Mieter', 'Mieteinheit', 'Mietmonat', 'Vorauszahlung', 'Warmmiete'];
    
    let modifiedData = data;
    placeholders.forEach(ph => {
      modifiedData = modifiedData.replaceAll(`<a href="#disabled" target="_self">${ph}</a>`, `<a href="#" target="_self">${ph}</a>`);
      modifiedData = modifiedData.replaceAll(`<a href="#disabled" class="rdw-mention-link">${ph}</a>`, `<a href="#" class="rdw-mention-link">${ph}</a>`);
    });
    return modifiedData;
  }

  onTab = (e) => {
    e.preventDefault(); 
    const { editorState } = this.state;
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    
    const blockType = contentState.getBlockForKey(selection.getStartKey()).getType();
    
    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
      const newState = RichUtils.onTab(e, editorState, 4); 
      if (newState !== editorState) {
        this.onEditorStateChange(newState);
      }
      return true;
    }
    
    const newContentState = Modifier.replaceText(
      contentState,
      selection,
      '\u00a0\u00a0\u00a0\u00a0' 
    );
    
    const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
    this.onEditorStateChange(newEditorState);
    return true;
  };

  customKeyBindingFn = (e) => {
    if (e.keyCode === 9) {
      const { editorState } = this.state;
      const selection = editorState.getSelection();
      const contentState = editorState.getCurrentContent();
      
      const blockType = contentState.getBlockForKey(selection.getStartKey()).getType();
      const isList = blockType === 'unordered-list-item' || blockType === 'ordered-list-item';

      if (e.shiftKey) {
        e.preventDefault();
        if (isList) {
          this.onTab(e);
          return 'handled-tab';
        }
        return 'outdent-text';
      } else {
        this.onTab(e); 
        return 'handled-tab';
      }
    }
    return getDefaultKeyBinding(e);
  };

  handleKeyCommand = (command, editorState) => {
    // --- 1. Custom Backspace Logic (Delete entire placeholder) ---
    if (command === 'backspace') {
      const selection = editorState.getSelection();
      
      if (selection.isCollapsed()) {
        const contentState = editorState.getCurrentContent();
        const block = contentState.getBlockForKey(selection.getStartKey());
        const startOffset = selection.getStartOffset();
        
        if (startOffset > 0) {
          const entityKey = block.getEntityAt(startOffset - 1);
          
          if (entityKey) {
            const entity = contentState.getEntity(entityKey);
            
            if (entity.getType() === 'LINK') {
              let entityStart = startOffset - 1;
              let entityEnd = startOffset;
              
              while (entityStart > 0 && block.getEntityAt(entityStart - 1) === entityKey) {
                entityStart--;
              }
              while (entityEnd < block.getLength() && block.getEntityAt(entityEnd) === entityKey) {
                entityEnd++;
              }
              
              const targetRange = selection.merge({
                anchorOffset: entityStart,
                focusOffset: entityEnd,
              });
              
              const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
              const newEditorState = EditorState.push(editorState, newContent, 'remove-range');
              this.onEditorStateChange(newEditorState);
              return 'handled';
            }
          }
        }
      }
    }

    // --- 2. Custom Tab Logic ---
    if (command === 'handled-tab') {
      return 'handled';
    }

    if (command === 'outdent-text') {
      const selection = editorState.getSelection();
      const contentState = editorState.getCurrentContent();
      const block = contentState.getBlockForKey(selection.getStartKey());
      const text = block.getText();
      const startOffset = selection.getStartOffset();

      const textBeforeCursor = text.slice(Math.max(0, startOffset - 4), startOffset);

      if (textBeforeCursor.match(/^[\u00a0 ]{4}$/)) {
        const targetRange = selection.merge({
          anchorOffset: startOffset - 4,
          focusOffset: startOffset,
        });

        const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
        const newEditorState = EditorState.push(editorState, newContent, 'remove-range');
        this.onEditorStateChange(newEditorState);
        return 'handled';
      }

      if (text.match(/^[\u00a0 ]{4}/)) {
        const targetRange = selection.merge({
          anchorOffset: 0,
          focusOffset: 4,
        });

        const newContent = Modifier.removeRange(contentState, targetRange, 'backward');
        const newEditorState = EditorState.push(editorState, newContent, 'remove-range');
        this.onEditorStateChange(newEditorState);
        return 'handled';
      }

      return 'not-handled'; 
    }

    // --- 3. Default Draft.js Commands ---
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      this.onEditorStateChange(newState);
      return 'handled';
    }

    return 'not-handled';
  }

  render() {
    const multipleTenants = this.props.history.location.state ? this.props.history.location.state.multipleTenants !== undefined ? this.props.history.location.state.multipleTenants : [] : [];
    const {tenant, selectedRecipients, dropdownIcon, openRecipientsModal, openMessagingPricingModal, paymentDetails, allRecipients, messageData, tenants, tenantsData, messageRecipientsLoader, postalFee, openPreviewModal, messageSavingLoader, subjectInFocus, messageDataOldState, openPostalFeeStatus, openMessageConfirmationModal, openMessageDeletionModal, isMobile, openBulkMessageDownloadModal, openAiMessageAssistantModal, messageSavingStatusPopper, senderInfo, messageTemplates, confirmMessageDeletionModal, selectedRecipientIdForEditing} = this.state;
    const {subject, body, status} = this.state.messageData;
    const {placeholders, accountData, showUtilityBillingMessages, billingPeriod, utilityBillingData, propertySelected, rentalPaymentId, messageType, loadingUbData=false, profile} = this.props;
    const senderInfoReroute = (propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled) ? '/property/propertyOwnerInformation' : '/profile/companyDetails';

    const senderInformationMissing = !senderInfo?.name || !senderInfo?.street || !senderInfo?.postalCode || !senderInfo?.city;
    console.log('myRef: ', this.myRef);
    console.log('accountData?: ', accountData);
    console.log('selectedTenants_123: ', selectedRecipients);
    console.log('allRecipients: ', allRecipients);
    console.log('messageData: ', messageData);
    console.log('tenants, tenantsData: ', tenants, tenantsData);
    console.log('subject: ', messageData.subject, messageDataOldState.subject);
    console.log('utilityBillingData: ', utilityBillingData);
    console.log('propertySelected: ', propertySelected);
    console.log('isMobile: ', isMobile);
    console.log('senderInfo: ', senderInfo);
    return (
      <div>
        <Stack>
          <Group align={'flex-start'} justify="space-between">
            <Stack gap={15} style={{width: '100%'}}>
              {/* In the flow rather than pinned to a fixed offset: the same content sits under
                  different headers (Nachrichten, Betriebskosten step 4), where it covered links */}
              {isMobile &&
              <Group justify="flex-end">
                {this.renderMessagingButtons()}
              </Group>}
              
              <Group justify="space-between" align={'flex-start'}>
                <Stack gap={15}>
                  <Stack gap={6}>
                    <lable>Empfänger</lable>
                    <Group align={'center'} style={{width: '100%', justifyContent: 'space-between'}} wrap="nowrap" gap={8}>
                      <Group onClick={()=> this.setState({openRecipientsModal: true})} style={{width: !isMobile && '560.5px', minWidth: isMobile ? '100%' : '300px'}}>
                        <Skeleton visible={loadingUbData}>
                          <CustomMultiSelect
                            data={allRecipients}
                            value={selectedRecipients}
                            className={`multi-select-messages-tenants ${selectedRecipients.length > 0 ? 'tenant-selector-input-with-values' : 'tenant-selector-input'}`}
                            placeholder="Empfänger bearbeiten"
                            onClick={() => this.setState({ openRecipientsModal: true })}
                            rightSection={messageRecipientsLoader && <Loader size="sm" type="dots" />}
                            style={{ width: isMobile ? '100%' : '560.5px' }}
                            searchable={false} // Internal dropdown isn't needed; clicking opens the Modal instead!
                            valueComponent={(props) => <Value {...props} onClick={(selectedRecipientId=null)=> this.setState({openRecipientsModal: true, selectedRecipientIdForEditing: selectedRecipientId})} messageData={messageData} />}
                            onChange={(e) => {
                              // Find which ID was removed by comparing the old array with the new one
                              const removedIds = this.state.selectedRecipients.filter(id => !e.includes(id));
                              
                              if (removedIds.length > 0) {
                                // Trigger backend deletion for the removed recipient
                                removedIds.forEach(id => {
                                  this.deleteMessageRecipient(id);
                                });
                                
                                // Remove from the master array so the UI and modals stay in sync
                                const newAllRecipients = this.state.allRecipients.filter(rec => e.includes(rec.id));
                                
                                this.setState({
                                  selectedRecipients: e,
                                  allRecipients: newAllRecipients,
                                  allRecipientsOldState: newAllRecipients
                                }, () => this.getMessagePostalFee()); 
                              } else {
                                // Fallback (e.g., if items were added, though adding usually happens via the modal)
                                this.setState({selectedRecipients: e});
                              }
                            }}
                          />
                        </Skeleton>
                      </Group>
                      {!isMobile &&
                      <Group>
                        {<div style={{display: 'flex', alignItems: 'center'}}>
                        <Tooltip title="Empfänger hinzufügen" >
                          <Skeleton visible={loadingUbData}>
                          <IconButton 
                            aria-label="filter list"
                            onClick={()=> this.setState({openRecipientsModal: true})} 
                            style={{
                              background: '#5655FE',
                              border: '1px solid #DADAE5', 
                              boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                              padding: '5px',
                              cursor: 'pointer'
                            }}>
                              <AddIcon 
                              style={{
                                color: 'white',
                                fontSize: '15px'
                                }}/>
                          </IconButton>
                          </Skeleton>
                        </Tooltip>
                        </div>}
                      </Group>}
                    </Group>
                  </Stack>
                  <Group wrap="nowrap">
                    <Stack gap={2} style={{width: !isMobile && '560.5px', minWidth: isMobile ? '100px' : '300px'}}>
                        <lable>Absender</lable>
                        {<Stack style={{width: '100%'}} gap={3}>
                          <Group wrap={!isMobile ? "nowrap" : "wrap"} gap={5}>
                            <Group wrap="nowrap" gap={6} align='flex-start' style={{fontWeight: '400', color: 'rgb(19, 19, 92)', fontSize: '14px'}}>
                              <span>
                                {senderInformationMissing ? //|| !senderInfo?.phoneNumber
                                <Group style={{cursor: 'pointer'}} wrap={!isMobile ? "nowrap" : "wrap"} gap={6} onClick={()=> {  
                                  hideNotification('accountInformationIncompleteError');      
                                  showNotification({
                                    message: <span>Die Absenderinformationen oder Absender-E-Mail sind unvollständig. Bitte ergänzen Sie die Kontaktdaten im <span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> this.props.history.push(senderInfoReroute)}>Nutzerkonto</span>.</span>,
                                    icon: <img src={RedCross} alt='red-cross' />,
                                    autoClose: false,
                                    id: 'accountInformationIncompleteError'
                                  })
                                }}>
                                  <img src={RedCross} alt='red-cross'/>
                                  <span style={{color: '#dc3545', fontWeight: '500', fontSize: '12px', whiteSpace: !isMobile && 'nowrap'}}>Absenderinformationen unvollständig</span>
                                </Group>
                                :
                                <Stack gap={0}>
                                  {/* Address */}
                                  {`Adresse: ${senderInfo?.name+','} ${senderInfo?.street+','} ${senderInfo?.postalCode} ${senderInfo?.city}`}
                                  {/* Phone */}
                                  <span>Telefon: <span style={{whiteSpace: 'nowrap'}}>{`${senderInfo?.phoneNumber || '-'}`}</span></span>
                                  {/* Email */}
                                  <span>
                                    Email:
                                    {!senderInfo?.email ?
                                    <Group style={{cursor: 'pointer'}} wrap="nowrap" gap={6} onClick={()=> {
                                      hideNotification('accountInformationIncompleteError');        
                                      showNotification({
                                        message: <span>Die Absender-E-Mail ist unvollständig. Bitte ergänzen Sie die Kontaktdaten im <span style={{color: '#5555FF', cursor: 'pointer'}} onClick={()=> this.props.history.push(senderInfoReroute)}>Nutzerkonto</span>.</span>,
                                        icon: <img src={RedCross} alt='red-cross' />,
                                        autoClose: false,
                                        id: 'accountInformationIncompleteError'
                                      })
                                    }}>
                                      <img src={RedCross} alt='red-cross'/>
                                      <span style={{color: '#dc3545', fontWeight: '500', fontSize: '12px', whiteSpace: 'nowrap'}}>Absender Email-Adresse fehlt</span>
                                    </Group>
                                    :
                                    <span style={{whiteSpace: 'nowrap'}}>{` ${senderInfo?.email}`}</span>}
                                  </span>
                                </Stack>}
                              </span>
                            </Group>
                          </Group>
                          <span onClick={()=> this.props.history.push(senderInfoReroute)} style={{fontSize: '12px', color: '#5555FF', cursor: 'pointer', fontWeight: 400, width: 'fit-content'}}>Kontaktdaten bearbeiten <img src={RightArrowPartner} style={{marginTop: '0px', width: '12px'}}/></span>
                        </Stack>}
                    </Stack>
                  </Group>
                  <Group>
                    {isMobile && this.renderAccountMessageBalanceAndEstimation()}
                  </Group>
                  <Stack gap={6} style={{width: !isMobile && '560.5px', minWidth: isMobile ? '100%' : '300px', marginTop: isMobile ? '8px' : '-19px'}}>
                    <lable>Betreff</lable>
                    <Group wrap="nowrap">
                      <div style={{width: '100%'}}>
                        <Skeleton visible={loadingUbData}>
                        <Editor
                        editorState={this.state.editorState}
                        toolbarClassName="message-subject-toolbar"
                        editorClassName="message-subject-editor"
                        id='message-subject-editor'
                        handleBeforeInput={this.handleSubjectBeforeInput} // <-- Added prop
                        handlePastedText={this.handleSubjectPastedText}
                        customDecorators={[
                          {
                            strategy: (contentBlock, callback, contentState) => {
                              contentBlock.findEntityRanges(
                                (character) => {
                                  const entityKey = character.getEntity();
                                  if (entityKey !== null) {
                                    const entity = contentState.getEntity(entityKey);
                                    if (entity.getType() === 'LINK') {
                                      const data = entity.getData();
                                      return data.url === '#disabled' || data.href === '#disabled';
                                    }
                                  }
                                  return false;
                                },
                                callback
                              );
                            },
                            component: ChordComponent,
                          }
                        ]}
                        toolbar={{
                          inline: {
                            strikethrough: { className: 'rdw-option-hide' },
                            monospace: { className: 'rdw-option-hide' },
                            superscript: { className: 'rdw-option-hide' },
                            subscript: { className: 'rdw-option-hide' },
                          },
                          list: {
                            indent: { className: 'rdw-option-hide' },
                            outdent: { className: 'rdw-option-hide' },
                            className: 'rdw-option-hide'
                          },
                          fontSize: {className: 'rdw-option-hide'},
                          textAlign: {className: 'rdw-option-hide'}
                        }}
                        editorRef={this.setSubjectEditorRef}
                        onEditorStateChange={this.onEditorStateChange}
                        localization={{
                          locale: 'de',
                        }}
                        onFocus={()=> this.setState({subjectInFocus: true})}
                        onBlur={()=> setTimeout(() => {
                          this.handleAutoSave();
                        }, 600)}
                        toolbarOnFocus
                        handleKeyCommand={this.handleKeyCommand}
                        keyBindingFn={this.customKeyBindingFn}
                        />
                        </Skeleton>
                      </div>
                      {isMobile &&
                      <Popover
  opened={messageSavingStatusPopper}
  trapFocus={false}
  position="top"
  // Added onChange to gracefully handle outside clicks
  onChange={(opened) => {
    if (!opened) this.setState({ messageSavingStatusPopper: false });
  }}
>
  {/* 1. Target Wrapper */}
  <Popover.Target>
    <div 
      style={{ display: 'inline-flex', alignItems: 'center' }}
      onFocusCapture={() => this.setState({ messageSavingStatusPopper: true })}
      onBlurCapture={() => this.setState({ messageSavingStatusPopper: false })}
    >
      {messageSavingLoader ? (
        <Loader 
          onClick={() => this.setState({ messageSavingStatusPopper: !messageSavingStatusPopper })} 
          size="xs" 
          style={{ cursor: 'pointer' }} // Moved cursor to style prop
        />
      ) : (
        <img 
          src={BlueTick} 
          alt="Gespeichert" 
          onClick={() => this.setState({ messageSavingStatusPopper: !messageSavingStatusPopper })} 
          style={{ minWidth: '16px', cursor: 'pointer' }}
        />
      )}
    </div>
  </Popover.Target>

  {/* 2. Dropdown Wrapper handles styling natively */}
  <Popover.Dropdown 
    bg="rgb(230, 230, 255)" 
    p={10} // Replaces styles={{ inner: { padding: '10px' } }}
  >
    {messageSavingLoader ? (
      <span style={{ fontSize: '14px', fontWeight: 400, fontFamily: 'Inter, sans-serif', color: '#13135C', marginTop: '-2px' }}>
        speichern
      </span>
    ) : (
      <span style={{ fontSize: '14px', fontWeight: 400, fontFamily: 'Inter, sans-serif', color: '#13135C', marginTop: '-2px' }}>
        gesichert
      </span>
    )}
  </Popover.Dropdown>
</Popover>}
                    </Group>
                  </Stack>
                </Stack>
                {!isMobile && this.renderMessagingButtons()}
              </Group>
            </Stack>
            
          </Group>
          
          <Skeleton visible={loadingUbData}>
            <MessagingEditor
            ref={this.messagingEditorRef}
            openAiAssistant={isAiFeatureVisible(accountData?.accountId) ? ()=> this.setState({openAiMessageAssistantModal: true}) : undefined}
            placeholders={placeholders}
            allRecipients={allRecipients}
            messageSavingLoader={messageSavingLoader}
            body={body}
            updateBody={(body)=> this.setState({messageData: {...this.state.messageData, body}},()=> this.handleAutoSave())}
            updateTemplateId={(templateId)=> this.setState({messageData: {...this.state.messageData, templateId}},()=> this.handleAutoSave())}
            subjectInFocus={subjectInFocus}
            onFocus={()=> this.setState({subjectInFocus: false})}
            addPlaceHolderToSubject={(html)=> this.addPlaceHolderToSubject(html)}
            isMobile={isMobile}
            propertySelected={propertySelected}
            accountData={accountData}
            profileData={profile}
            messageData={messageData}
            messageTemplates={messageTemplates}
            subject={subject}
            messageType={messageType}
            getTemplates={()=> this.getMessageTemplates({updateOnlyTemplatesList: true})}
            downloadAllAsPdf={!isMobile &&
            // <Group wrap="nowrap" gap={0}>
            //   <Group wrap="nowrap" gap={0}>
            //     <Group wrap="nowrap" style={{fontSize: '12px', fontWeight: '400', color: '#5555FF', cursor: 'pointer'}} gap={5} onClick={()=> !loadingUbData && this.setState({openBulkMessageDownloadModal: true})}><Skeleton visible={loadingUbData}>Alle herunterladen (PDF) <img src={RightArrowPartner} style={{marginTop: '2px', width: '12px'}}/></Skeleton></Group>
            //   </Group>
            // </Group>
            <div>
              <span style={{color: 'rgb(69, 69, 118)', fontSize: '14px', fontFamily: 'Inter, sans-serif', fontWeight: '400'}}>Alle herunterladen (PDF):</span>
              <MantineTooltip label='Alle Empfängernachrichten als PDF herunterladen' disabled={selectedRecipients?.length === 0}>
                <IconButton 
                aria-label="filter list"
                //disabled={selectedRecipients.length === 0}
                onClick={()=> selectedRecipients.length > 0 && (!loadingUbData && this.setState({openBulkMessageDownloadModal: true}))}
                style={{
                  marginLeft: '8px',
                  background: 'white',
                  border: '1px solid #DADAE5', 
                  boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                  padding: '5px',
                  cursor: selectedRecipients.length === 0 ? 'not-allowed' : 'pointer',
                  opacity: selectedRecipients.length === 0 ? 0.8 : 1
                  }}>
                  <img src={PdfIcon} style={{width: '16px', height: '16px', minWidth: '16px', minHeight: '16px'}} />
                </IconButton>
              </MantineTooltip>
            </div>}
            //setMessageTemplates={(templates)=> setMessageTemplates(templates)}
            />
          </Skeleton>
          {/* <MessagingEditorMantine/> */}
          
          {/* <Group style={{justifyContent: 'flex-end'}}>
              <div>
                  <ColorButton
                  text={'Send'}
                  className={'purple-btn'}
                  onClick={()=> null}
                  />
              </div>
          </Group> */}
        </Stack>
        {openRecipientsModal &&
        <AddMessagingRecipientsModal
        messageId={messageData.id}
        messageData={messageData}
        open={openRecipientsModal}
        tenants={tenants}
        selectedRecipientIdForEditing={selectedRecipientIdForEditing}
        messageType={messageType}
        showUtilityBillingMessages={showUtilityBillingMessages}
        toggle={()=> this.setState({openRecipientsModal: false, selectedRecipientIdForEditing: null},()=> this.getMessageRecipientsByMessageId(messageData.id))}
        previouslySelectedRecipients={allRecipients}
        getMessageRecipientsByMessageId={()=> this.getMessageRecipientsByMessageId(messageData.id)}
        setSelectedRecipients={(selectedRecipients)=> this.setState({selectedRecipients: selectedRecipients.sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase())).map((recipient)=> `${recipient.tenantId}`), allRecipients: selectedRecipients})}
        isMobile={isMobile}
        disableRecipientSelection={messageData?.templateType === 'RentalPayment'}
        disableTenantsSelection={false}//messageData?.templateType === 'General'}
        disableExternalContactsAdd={(messageData?.templateType === 'Tenant' || messageData?.templateType === 'RentalPayment' || messageData?.templateType === 'BillingStatement')}
        />}
        {openMessagingPricingModal &&
        <MessagingPricingModal
        open={openMessagingPricingModal}
        history={this.props.history}
        paymentDetails={paymentDetails}
        toggle={()=> this.setState({openMessagingPricingModal: false})}
        putTopUpCredit={(amount)=> this.putTopUpCredit(amount)}
        isMobile={isMobile}
        />}
        {openPreviewModal && allRecipients &&
        <MessagePreviewModal
        open={openPreviewModal}
        multipleTenants={multipleTenants}
        toggle={()=> this.setState({openPreviewModal: false})}
        allRecipients={allRecipients}
        messageData={messageData}
        senderAddress={senderInformationMissing ? <span style={{color: '#dc3545', fontWeight: '500'}}>Absenderinformationen unvollständig</span> : ` ${senderInfo?.name+','} ${senderInfo?.street+','} ${senderInfo?.postalCode} ${senderInfo?.city}`}
        senderEmail={senderInfo?.email}
        billingPeriod={billingPeriod}
        isMobile={isMobile}
        />}
        {openMessageConfirmationModal &&
        <MessageConfirmationModal
        open={openMessageConfirmationModal}
        postalFee={postalFee}
        allRecipients={allRecipients}
        onSend={()=> this.putPublishMessagesById()}//messageType === 'TenantSignUp' ? this.putPublishMessagesById() : messageData.templateType === 'RentalPayment' ? this.evaluateRentalPayments() : this.putPublishMessagesById()}
        toggle={()=> this.setState({openMessageConfirmationModal: false})}
        />}
        {openMessageDeletionModal &&
        <MessageDeleteModal
          open={openMessageDeletionModal}
          confirmMessageDeletionModal={confirmMessageDeletionModal}
          toggle={() => this.setState({openMessageDeletionModal: false, confirmMessageDeletionModal: false})}
          goBack={this.handleGoBack} // <-- Update this line
          onDelete={() => this.deleteMessagesById(messageData.id)}
        />}

        {openBulkMessageDownloadModal &&
        <BulkDownloadForMessageModal
        open={openBulkMessageDownloadModal}
        multipleTenants={multipleTenants}
        toggle={()=> this.setState({openBulkMessageDownloadModal: false})}
        allRecipients={allRecipients}
        messageData={messageData}
        senderAddress={senderInformationMissing ? <span style={{color: '#dc3545', fontWeight: '500'}}>Absenderinformationen unvollständig</span> : ` ${senderInfo?.name+','} ${senderInfo?.street+','} ${senderInfo?.postalCode} ${senderInfo?.city}`}
        senderEmail={senderInfo?.email}
        billingPeriod={billingPeriod}
        isMobile={isMobile}
        />}
        {openAiMessageAssistantModal &&
        <AiMessageAssistantModal
        open={openAiMessageAssistantModal}
        toggle={()=> this.setState({openAiMessageAssistantModal: false})}
        templateType={messageData?.templateType || this.getTemplateType()}
        allowedPlaceholders={this.getAiAllowedPlaceholders()}
        currentSubject={messageData?.subject}
        currentBody={messageData?.body}
        accountData={accountData}
        profileData={profile}
        propertyId={propertySelected?.id}
        onApply={this.applyAiGeneratedMessage}
        />}
        <button id='publishMessage' style={{display: 'none'}}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentDataId: state.UtilityBillingReducer.currentBillingId,
    utilityBillingData: state.UtilityBillingReducer.utilityBillingData,
    propertySelected: state.generalReducer.property,
    rentalUnits: state.tenantDataReducer.rentalUnits,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData,
    profile: state.generalReducer.profile
  };
};

const mapDispatchToProps = {
  setUtilityBillingData,
  setCurrentBillingId,
  setPublishMessageId,
  setAccountData,
  setCurrentMessagesData
};

export default connect(mapStateToProps, mapDispatchToProps)(NewMessageInnerContent);
